@if (phoneNumber() || phoneNumberService()) {
    <a
        [class]="elStyle.buttonMobile.container"
        [href]="'tel:' + (phoneNumberService() ?? phoneNumber())"
        aria-label="Phone"
    >
        <span
            [class]="elStyle.buttonMobile.button"
            [svgAwesome]="'assets/icons/phone.svg'"
            [classList]="[elStyle.buttonMobile.icon]"
            priority
        ></span>
    </a>
}

<div [class]="elStyle.buttonDesktop.container">
    <button
        [class]="elStyle.buttonDesktop.button"
        [svgAwesome]="'assets/icons/phone.svg'"
        [classList]="[elStyle.buttonDesktop.icon]"
        (click)="toggleVisibility()"
        priority
        aria-label="Phone"
    ></button>
    <div
        [class]="elStyle.buttonDesktop.textContainer"
        [style.width]="
            contentVisible() ? elStyle.buttonDesktop.textContainerVisible : elStyle.buttonDesktop.textContainerHidden
        "
    >
        <p [class]="elStyle.buttonDesktop.textLabel">{{ desktopText() }}</p>
        @if (phoneNumber() || phoneNumberService()) {
            <a
                [class]="elStyle.buttonDesktop.textPhoneNumber"
                [href]="'tel:' + (phoneNumberService() ?? phoneNumber())"
            >
                {{ phoneNumberService() ?? phoneNumber() }}
            </a>
        }
    </div>
</div>
